module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.compIsVisible) ? _c('div', {
    staticClass: "edit_bar"
  }, [_vm._l((_vm.compButtons), function(button) {
    return _c('div', {
      staticClass: "k1_edit_sect"
    }, [_c('span', {
      staticClass: "h7 c-dark upcase medium"
    }, [_vm._v(_vm._s(button.title))]), _vm._v(" "), _c('step-btn', {
      attrs: {
        "steps": button.steps,
        "current": typeof button.current === 'function' ? button.current() : button.current
      },
      on: {
        "change": button.onChange
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "k1_edit_right"
  }, [(_vm.compShowDelete) ? _c('button', {
    staticClass: "k1_edit_btn",
    on: {
      "click": _vm.emitOnDelete
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/delete.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "k1_edit_btn bg-accent",
    on: {
      "click": _vm.emitOnConfirm
    }
  }, [_c('span', {
    staticClass: "h7 upcase regular c-light"
  }, [_vm._v(_vm._s(_vm.$t("confirm")))])])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccd8034e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/Editbar.vue
// module id = 662
// module chunks = 0